import React, { useState } from 'react';

import { useFetchEnergyAudit } from 'api/audit/EnergyAuditService';
import BenefitsIcon from 'components/icons/AuditIcons/BenefitsIcon';
import RisksIcon from 'components/icons/AuditIcons/RisksIcon';
import SubsidiesIcon from 'components/icons/AuditIcons/SubsidiesIcon';
import ActionPlanIcon from 'components/icons/AuditIcons/ActionPlanIcon';
import MethodologyIcon from 'components/icons/AuditIcons/MethodologyIcon';
import { useParams } from 'react-router-dom';
import { useFetchMeterByConnectionPoint } from 'api/assets/metersServices';
import EnergyAuditHeader from './components/EnergyAuditHeader';
import EnergyAuditSummaryCard from './components/EnergyAuditSummaryCard';
import EnergyAuditTabs from './components/EnergyAuditTabs';
import { BackButton } from '@components/backButton';
import { useNotFoundPage } from 'hooks/useNotFoundPage';

const tabs = [
  {
    label: 'Benefits',
    key: 'benefits',
    icon: (active: boolean) => <BenefitsIcon active={active} />,
  },
  {
    label: 'Risk & Compliance',
    key: 'risk_compliance',
    icon: (active: boolean) => <RisksIcon active={active} />,
  },
  {
    label: 'Subsidies',
    key: 'subsidies',
    icon: (active: boolean) => <SubsidiesIcon active={active} />,
  },
  {
    label: 'Action Plan',
    key: 'action_plan',
    icon: (active: boolean) => <ActionPlanIcon active={active} />,
  },
  {
    label: 'Methodology',
    key: 'methodology',
    icon: (active: boolean) => <MethodologyIcon active={active} />,
  },
];

const EnergyAuditPage: React.FC = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('benefits');
  const { data, isFetching } = useFetchEnergyAudit(id);
  const {
    data: meterData,
    isFetching: isMeterFetching,
    error,
    isError,
  } = useFetchMeterByConnectionPoint(id);
  const isPageFetching = isFetching || isMeterFetching;
  const { validateAndRedirectToNotFound } = useNotFoundPage();

  const mainBuildingId = data?.energy_audit?.main_building_id;
  const backButtonPath = mainBuildingId
    ? `/app/assets/building/details/${mainBuildingId}`
    : '/app/assets/list#assets';

  validateAndRedirectToNotFound(isError, error);

  return (
    <div className="flex flex-col gap-8 max-w-[1272px] mx-auto mt-7">
      <BackButton navigateTo={backButtonPath} />
      <div className="flex flex-col gap-8">
        <EnergyAuditHeader
          data={meterData?.meter}
          isFetching={isPageFetching}
          isLegallyRequired={data?.energy_audit?.is_legally_required}
          auditCategory={data?.energy_audit?.energy_conservation_measure}
          effort={data?.energy_audit?.analytic_type}
        />
        <EnergyAuditSummaryCard
          data={data?.energy_audit}
          isFetching={isPageFetching}
        />
        <EnergyAuditTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          data={data?.energy_audit}
          tabs={tabs}
          isFetching={isPageFetching}
        />
      </div>
    </div>
  );
};

export default EnergyAuditPage;
